import React from "react";
import "./pricing.css";
import ComparisonRow from "./ComparisonRow";

const PricingComparison = () => {
  const comparisons = [
    {
      icon: "handshake",
      feature: "Direct KOL Access",
      subtitle: "400+ verified KOLs",
      ourAdvantage: { title: "Direct KOL Access", subtitle: "Work directly with vetted influencers" },
      competitorDisadvantage: { title: "Middlemen", subtitle: "Indirect access, slower execution" },
      delay: 0.1,
    },
    {
      icon: "eye",
      feature: "Transparent Pricing",
      subtitle: "No hidden fees",
      ourAdvantage: { title: "Transparent Pricing", subtitle: "Clear quotes, tracked outcomes" },
      competitorDisadvantage: { title: "Hidden Fees", subtitle: "Unclear margins & markups" },
      delay: 0.2,
    },
    {
      icon: "dollar",
      feature: "Cost Efficiency",
      subtitle: "ROI-first planning",
      ourAdvantage: { title: "60% More Cost-Effective", subtitle: "Optimized media allocation" },
      competitorDisadvantage: { title: "Premium Pricing", subtitle: "Pay more for less impact" },
      delay: 0.3,
    },
    {
      icon: "people",
      feature: "Quality Results",
      subtitle: "Investor-facing outcomes",
      ourAdvantage: { title: "Performance Focused", subtitle: "Reach, volume & community KPIs" },
      competitorDisadvantage: { title: "Vanity Metrics", subtitle: "Impressions without traction" },
      delay: 0.4,
    },
  ];

  return (
    <div className="comparison-table">
      {/* Table Header */}
      <div className="comparison-header">
        <div className="header-cell feature-header">FEATURES</div>
        <div className="header-cell our-platform-header">
          <div className="platform-badge">
            <div className="platform-name">Charamy.org</div>
            <div className="platform-label">Our Platform</div>
          </div>
        </div>
        <div className="header-cell competitor-header">
          <div className="platform-badge">
            <div className="platform-name">Competitors</div>
            <div className="platform-label">Others</div>
          </div>
        </div>
      </div>

      {/* Comparison Rows */}
      <div className="comparison-rows">
        {comparisons.map((comparison, index) => (
          <ComparisonRow key={index} {...comparison} />
        ))}
      </div>
    </div>
  );
};

export default PricingComparison;